export default {
  button: {
    confirm: 'Confirm',
    login: 'Login',
  },
}
